module.exports = __webpack_public_path__ + "img/nt54-02-80-1-asm.prt.005d21b2.jpg";